import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { useMe } from "@/lib/hooks/use-me";

export function useShiftsForProject(projectId?: string) {
  const { me } = useMe();

  return useQuery({
    queryKey: ["shifts", projectId, me?.employee?.id],
    queryFn: () =>
      extractionWrapper(
        api.shift.getAll({
          filter: {
            projectId: {
              value: projectId,
              operator: "equals",
            },
            employeeId: {
              value: me?.employee?.id,
              operator: "equals",
            },
          },
          include: {
            project: {
              select: true,
            },
            position: {
              select: true,
            },
          },
          sort: {
            field: "startAt",
            order: "asc",
          },
        }),
      ),
    enabled: !!projectId && !!me?.employee?.id,
  });
}
